module.exports = __webpack_public_path__ + "static/media/listing-page-mussoorie.e8fd8bdb.jpg";